import { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import {
	Badge,
	Button,
	Flex,
	Icon,
	Image,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalOverlay,
	Radio,
	SimpleGrid,
	Text,
	Textarea,
  useToast
} from "@chakra-ui/react";
import { FiCheck, FiMinus, FiPlus } from "react-icons/fi";

import { useCart } from "../../hooks/cart";
import api from "../../services/api";
import { formatPrice } from "../../utils/format";
import { AppError } from "../../utils/AppError";

type ProdutoData = {
	id: string;
	categoria: string;
	cod_barras: string;
	cod_pro: string;
	comiss_ind: number;
	comiss_ven: number;
	complementos: ComplementoData[];
	descricao: string;
	nome: string;
	obs: string;
	promocao: string;
	qtd: number;
	total: number;
	url_imagem: string;
	valor: number;
}
type ComplementoData = {
	codigo: number;
	grupo: number;
	nome: string;
	descricao: string;
	custo: number;
	valor: number;
	priceFormatted: string;
	qtd_maxima: number;
	qtd_gratis: number;
	qtd: number;
}
type GrupoDATA = {
	codigo: number;
	nome: string;
	obrigatorio: string;
	min_itens: number;
	max_itens: number;
	qtd: number;
}
type ObsData = {
	obs: string;
}

interface ModalItemProps {
	isOpen: boolean;
	onRequestClose: (close: boolean) => void;
	produto: ProdutoData;
	incluir: boolean;
}

const ModalItem: React.FC<ModalItemProps> = ({
	isOpen,
	onRequestClose,
	produto,
	incluir,
}) => {
	const { cart, addCart, resetCartPagamento } = useCart();
  const toast = useToast();

	const [loading, setLoading] = useState(true);
	const [btnAddDisabled, setAddBtnDisabled] = useState(true);

	const [product, setProduct] = useState<ProdutoData>({} as ProdutoData);
	const [grupos, setGrupos] = useState<GrupoDATA[]>([]);
	const [obsLength, setObsLength] = useState(0);

	const [w, setW] = useState<number>(20);

	const { register, setValue } = useForm<ObsData>({
	});

  async function fetchProduct() {
    try {
      const { data } = await api.get(`controle/produto/${produto.cod_pro}`);

      data.produto.cod_pro = data.produto.id;

      // Verifica se existe os complementos produto
      if (produto.complementos?.length > 0) {
        for (let i = 0; i < data.complementos.length; i++) {
          const index = produto.complementos?.findIndex(comp =>
            comp.codigo === data.complementos[i].codigo
          );

          if (index >= 0) {
            data.complementos[i].qtd = produto.complementos[index].qtd;
          }
        }
      }
      produto.complementos = data.complementos;
      //

      const filtered = data.grupos.filter(
        (item: GrupoDATA) => item.obrigatorio === 'S'
      );

      if (filtered.length === 0) {
        setAddBtnDisabled(false);
      };

      setGrupos(data.grupos);

      if (incluir) {
        setProduct(data.produto);

        if (data.complementos.length === 0) {
          setAddBtnDisabled(false);
        }

        setLoading(false);
      } else {
        setValue('obs', produto.obs);
        const auxProduto = produto;
        const auxGrupos = data.grupos;

        if (auxProduto.complementos && auxProduto.complementos.length > 0) {
          auxProduto.complementos.map(comp => {
            const indexG = auxGrupos.findIndex(
              (item: GrupoDATA) => item.codigo === comp.grupo,
            );

            if (auxGrupos[indexG].max_itens > 0) {
              if (comp.qtd > 0) {
                auxGrupos[indexG].qtd += comp.qtd;
              }
            }

            if (auxGrupos.length > 0) {
              if (auxGrupos[indexG].obrigatorio === 'S') {
                if (auxGrupos[indexG].qtd < auxGrupos[indexG].max_itens) {
                  setAddBtnDisabled(true);
                } else if (auxGrupos[indexG].qtd === auxGrupos[indexG].max_itens) {
                  setAddBtnDisabled(false);
                }
              } else {
                setAddBtnDisabled(false);
              }
            } else {
              setAddBtnDisabled(false);
            }

            return comp;
          });
        } else {
          setAddBtnDisabled(false);
        }

        setGrupos(auxGrupos);
        setProduct(auxProduto);
        setLoading(false);
      }
    }
    catch (error) {
      const isAppError = error instanceof AppError;
      const description = isAppError ? error.message : 'Não foi possível localizar o produto.';

      toast({
        title: 'Produto Falhou.',
        description,
        status: 'error',
        duration: 5000,
        position: 'top-right',
        isClosable: true,
      });
    }
    finally {
      setLoading(false);
    }
  }

	useEffect(() => {
		fetchProduct();
	}, []);

	function handleAddQtd(qtd: number, operator: string) {
		let total = 0;
		let auxQtd = qtd;

		if (operator === '+') {
			auxQtd += 1;
			total = product.total + product.valor;
		} else {
			if (qtd === 1) {
				return;
			}

			auxQtd -=1;
			total = product.total - product.valor;
		}

		setProduct({
			...product,
			qtd: auxQtd,
			total,
		});
	}

	function handleAddComplemento(comp: ComplementoData, operator: string) {
		const auxComps = product.complementos;
		const auxGrupos = grupos;

		const indexComp = auxComps.findIndex(item => item.codigo === comp.codigo);
		const indexG = auxGrupos.findIndex(item => item.codigo === comp.grupo);

		const complemento = auxComps[indexComp];
		const grupo = auxGrupos[indexG];

		let { total } = product;

		if (operator === '+') {
			if (grupo.max_itens !== 0 && grupo.qtd < grupo.max_itens) {
				if (comp.qtd < comp.qtd_maxima) {
					auxGrupos[indexG].qtd += 1;
					auxComps[indexComp].qtd += 1;

					if (comp.qtd > comp.qtd_gratis) {
						total = product.total + comp.valor;
					}
				}
			} else if (grupo.max_itens === 0) {
				if (comp.qtd < comp.qtd_maxima) {
					auxGrupos[indexG].qtd += 1;
					auxComps[indexComp].qtd += 1;

					if (comp.qtd > comp.qtd_gratis) {
						total = product.total + comp.valor;
					}
				}
			}
		} else {
			if (complemento.qtd === 0) {
				return;
			}

			if (complemento.qtd > complemento.qtd_gratis) {
				total = product.total - comp.valor;
			}

			auxGrupos[indexG].qtd -= 1;
			auxComps[indexComp].qtd -= 1;
		}

		setProduct({
			...product,
			complementos: auxComps,
			total,
		});
		setGrupos(auxGrupos);

		//Verifica se todos complementos obrigatórios forma selecionados
		let verif = false;
		for (let i = 0; i < auxGrupos.length; i++) {
			if (auxGrupos[i].obrigatorio === 'S' && auxGrupos[i].qtd < auxGrupos[i].max_itens) {
				verif = true;
			}
		}

		setAddBtnDisabled(verif ? true : false);
	}

	function handleAddCompRadio(comp: ComplementoData) {
		const auxComps = product.complementos;
		const auxGrupos = grupos;

		const indexG = auxGrupos.findIndex(grupo => grupo.codigo === comp.grupo);
		const indexComp = auxComps.findIndex(
			item => item.codigo === comp.codigo && item.grupo === comp.grupo);
		const compBeforeIndex = auxComps.findIndex(
			item => item.grupo === comp.grupo && item.qtd > 0);

		const grupo = auxGrupos[indexG];
		const complemento = auxComps[indexComp];
		const compBefore = auxComps[compBeforeIndex];

		let { total } = product;

		//se não for grátis subtrai do total
		if (complemento.qtd_gratis === 0) {
			if (compBeforeIndex >= 0 && compBefore.grupo === comp.grupo) {
				total -= compBefore.valor;
			}

			total += comp.valor;
		}

		// adiciona a quantidade no complemento
		if (comp.qtd === 0) {
			comp.qtd = 1;
			// se ouver outro complemento com a qtd = 1, ai zera
			auxComps.map(item => {
				if (item.grupo === comp.grupo) {
					item.qtd = 0;
				}
				return item;
			});

			auxGrupos[indexG].qtd = 1;
			auxComps[indexComp].qtd = 1;
		} else if (comp.qtd === 1) {
			// se não for obrigatório pode descelecionar
			if (grupo.obrigatorio === 'N') {
				auxGrupos[indexG].qtd = 0;
				auxComps[indexComp].qtd = 0;
				// se não for grátis subtrai do total
				if (complemento.qtd_gratis === 0) {
					if (compBeforeIndex >= 0 && compBefore.grupo === comp.grupo) {
						total -= compBefore.valor;
					}
				}
			}
		}

		setProduct({
			...product,
			complementos: auxComps,
			total,
		});
		setGrupos(auxGrupos);

		//Verifica se todos complementos obrigatórios forma selecionados
		let verif = false;
		for (let i = 0; i < auxGrupos.length; i++) {
			if (auxGrupos[i].obrigatorio === 'S' && auxGrupos[i].qtd < auxGrupos[i].max_itens) {
				verif = true;
			}
		}

		setAddBtnDisabled(verif ? true : false);
	}

	function handleAddCart() {
		addCart(product, incluir);

		if (cart.pagamentos.length > 0) {
			resetCartPagamento();
		}

		onRequestClose(false);
	}

	function handleChangeQtd(value: string) {
		let res = value;
		res = res.replace(/\D/g, '');

		setW(res.length > 1 ? res.length * 10 : 20);

		setProduct({
			...product,
			qtd: Number(res),
			total: product.valor * Number(res)
		});
	}

	function handleBlurQtd() {
		if (product.qtd === 0) {
			setProduct({
				...product,
				qtd: 1,
				total: product.valor
			});
		}
	}

	return (
		<Modal
			isCentered={true}
			size="3xl"
			isOpen={isOpen}
			onClose={() => onRequestClose(false)}
		>
			<ModalOverlay />
			{!loading && (
				<ModalContent mt="auto">
					<ModalCloseButton />

					<ModalBody>
						<Flex flexDir={["column", "row"]} justify="space-between">
							<Flex justify="center" align="center" w="auto" h="auto">
								<Image
									h="auto"
									w="auto"
									maxW={["280px", "300px"]}
									maxH={["300px", "350px"]}
									borderRadius="10"
									objectFit='cover'
									src={produto.url_imagem
										? produto.url_imagem
										: "https://safetycloud.blob.core.windows.net/cashback-promocoes/placeholder-image.png"}
									alt={produto.nome}
								/>
							</Flex>

							<Flex
								p="2"
								flexDir="column"
								w="100%"
								h="auto"
								maxH="500px"
								overflowY="auto"
								scrollBehavior="smooth"
								sx={{
									'::-webkit-scrollbar': {
										scrollBehavior: "smooth",
									}
								}}
							>
								<Text pb="4" fontSize="15" fontWeight="500" color="gray.700">{produto.nome}</Text>
								<Text fontSize="14" color="gray.600">{produto.descricao}</Text>
								<Text p="2" px="4" fontSize="15" fontWeight="500" color="gray.700">
									{formatPrice(produto.valor)} - Código {produto.cod_barras}
								</Text>

								<SimpleGrid columns={1} spacingY="4" pb="4">
									{grupos[0]?.codigo && grupos?.map((grupo, indice) => {
										return (
											<Flex id="grupos" key={indice} flexDir="column">
												<Flex id="grupo" flexDir="column" p="2" w="100%" bg="gray.50">
													<Text fontWeight="500">{grupo.nome}</Text>
													<Flex justify="space-between" w="100%">
														<Text fontSize="14" color="gray.400">Escolha as opções</Text>
														{grupo.max_itens > 0 && (
															grupo.max_itens === grupo.qtd ? (
																<Icon as={FiCheck} color="green.500" fontSize="20" />
															) : (
																<Flex align="center">
																	<Badge
																		fontSize="sm"
																		colorScheme={grupo.obrigatorio === 'S' ? 'red' : 'gray'}
																	>
																		{grupo.qtd}/{grupo.max_itens}
																	</Badge>
																	{grupo.obrigatorio === 'S' && (
																		<Badge ml="2" colorScheme='red'>Obrigatório</Badge>
																	)}
																</Flex>
															)
														)}
													</Flex>
												</Flex>

												<Flex id="complementos" flexDir="column">
													{product.complementos?.map((comp, indice) => {
														return (
															grupo.codigo === comp.grupo && (
																<Flex
																	id="complemento"
																	key={indice}
																	w="100%"
																	px="4"
																	justify="space-between"
																	align="center"
																>
																	<Flex flexDir="column" p="1" justify="center">
																		<Text fontSize="14">{comp.nome}</Text>
																		<Text fontSize="13" color="gray.500">{comp.descricao}</Text>
																		<Text fontSize="13" pl="2">
																			+{' '}
																			{comp.qtd < comp.qtd_gratis
																				? 'R$ 0,00'
																				: formatPrice(comp.valor)
																			}
																		</Text>
																	</Flex>

																	<Flex id="complemento-add" justify="center">
																		{grupo.max_itens === 1 ? (
																			<Radio size="lg" name='1' colorScheme='blue'
																				isChecked={comp.qtd > 0 ? true : false}
																				onClick={() => handleAddCompRadio(comp)}
																			/>
																		) : (
																			<Flex id="btn-mais-menos" justify="center">
																				{comp.qtd > 0 && (
																					<Flex justify="center" align="center">
																						<Text
																							as="button"
																							onClick={() => handleAddComplemento(comp, '-')}
																						>
																							<Icon as={FiMinus} pt="2" color="blue.200" fontSize="24" />
																						</Text>
																						<Text>{comp.qtd}</Text>
																					</Flex>
																				)}

																				<Text
																					as="button"
																					onClick={() => handleAddComplemento(comp, '+')}
																				>
																					<Icon as={FiPlus} pt="2" color="blue.200" fontSize="24" />
																				</Text>
																			</Flex>
																		)}
																	</Flex>
																</Flex>
															)
														)
													})}
												</Flex>
											</Flex>
										)
									})}
								</SimpleGrid>

								<Flex
									as="form"
									w="100%"
									px="2"
									flexDir="column"
									borderTopWidth={1}
									borderTopColor="gray.200"
								>
									<Flex justify="space-between" p="2">
										<Text fontSize="15" color="gray.600">Algum comentário?</Text>
										<Text fontSize="15" color="gray.600">{obsLength ? obsLength : 0}/150</Text>
									</Flex>

									<Textarea
										borderRadius="6"
										placeholder='Digite seu comentário.'
										size='sm'
										maxLength={150}
										{...register('obs')}
										onChange={(e) => {
											setObsLength(e.target.value.length);
											setProduct({ ...product, obs: e.target.value });
										}}
									/>
								</Flex>
							</Flex>
						</Flex>
					</ModalBody>

					<ModalFooter pt={["0", "2"]}>
						<Flex
							flexDir={['column', 'row', 'row', 'row']}
							justify={['center', 'flex-end', 'flex-end', 'flex-end']}
							align={['center', 'flex-end', 'flex-end', 'flex-end']}
							w="100%"
						>
							<Flex
								align="center"
								mb={["2", "0"]}
								borderWidth={1}
								borderColor="gray.300"
								borderRadius="6"
							>
								<Text
									as="button"
									p="1"
									pt="2"
									onClick={() => handleAddQtd(product?.qtd, '-')}
								>
									<Icon as={FiMinus} color="blue.500" />
								</Text>

								{/* <Text p="1">{product?.qtd}</Text> */}
								<Input
									cursor="pointer"
									textAlign="center"
									variant="unstyled"
									p="0"
									w={`${w}px`}
									//maxWidth="72px"
									value={product.qtd}
									onChange={e => handleChangeQtd(e.target.value)}
									onBlur={handleBlurQtd}
								/>

								<Text
									as="button"
									p="1"
									pt="2"
									onClick={() => handleAddQtd(product?.qtd, '+')}
								>
									<Icon as={FiPlus} color="blue.500" />
								</Text>
							</Flex>

							<Flex>
								<Button colorScheme='blue' ml="4" isDisabled={btnAddDisabled} onClick={handleAddCart}>
									{incluir ? 'ADICIONAR' : 'EDITAR'}&nbsp;&nbsp;&nbsp;&nbsp;
									{formatPrice(product?.total)}
								</Button>
							</Flex>
						</Flex>
					</ModalFooter>
				</ModalContent>
			)}
		</Modal>
	)
}

export default ModalItem;
